import { ISbRichtext } from '@storyblok/react';
import { FC } from 'react';
import { ProductGuideItemStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { LinkWithIcon } from 'atoms/LinkWithIcon';
import { H2, H3, H4, P } from 'atoms/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import styles from './styles.module.css';

export const Item: FC<{
  data: ProductGuideItemStoryblok;
  href: string;
  description?: string | ISbRichtext;
}> = ({ data, href, description }) => {
  return (
    <div className={styles.item}>
      <Link
        href={href}
        target={data.link?.target}
        className={styles.imageContainer}
      >
        {data.image?.filename && (
          <Image
            src={data.image.filename}
            alt={data.image?.alt}
            className={styles.image}
          />
        )}
      </Link>
      <div className={styles.textBlock}>
        <div className={styles.markDown}>
          {description && (
            <RichTextMarkdown
              text={description}
              components={{
                h2: ({ children }) => <H2>{children}</H2>,
                h3: ({ children }) => <H3 className={styles.h3}>{children}</H3>,
                h4: ({ children }) => <H4 className={styles.h4}>{children}</H4>,
                p: ({ children }) => <P className={styles.p}>{children}</P>,
              }}
            />
          )}
        </div>
        {data?.text_link && (
          <LinkWithIcon
            href={href}
            text={data.text_link}
            className={styles.link}
            target={data.link?.target}
          />
        )}
      </div>
      {/* it's necessary for the correct background opacity  */}
      <div
        className={styles.background}
        style={{ backgroundColor: data?.background_color?.color }}
      />
    </div>
  );
};
